export const lookupFormInitialValues = {
    id: 0,
    text: "",
    code: "",
    lookupid: undefined,
    systemCreated: false,
    lookupParentCode: undefined,
};
